// Progressive enhancement only. Shopify renders each selected variant server-side.
document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const url = new URL(select.form.action, location.href);
  url.searchParams.set('variant', select.value);
  if (select.form.elements.preview?.value === '1') url.searchParams.set('preview', '1');
  location.assign(url.href);
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const professional = document.querySelector('.professional-menu[open]');
  if (professional) { professional.open = false; professional.querySelector('summary').focus(); return; }
  const menu = document.querySelector('.mobile-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});

document.addEventListener('click', event => {
  document.querySelectorAll('.professional-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});
